<template>
  <div class="row">
    <LoaderMaskComponent v-if="lyLoading" />
    <div v-else class="col_12">
      <div class="d_flex_btwn">
        <h1 class="common_title">
          <span v-if="$route.params.id">Edit Inventory</span>
          <span v-else>Create a New Inventory</span>
        </h1>
        <span>
          <router-link :to="{ name: 'inventories' }" class="btn btn_black"
            >Back to List</router-link
          >
        </span>
      </div>
      <div class="card border_none">
        <div class="card_body pl_0 pr_0">
          <div class="row">
            <div class="col_6 pr_20">
              <div
                :class="[
                  'form_row',
                  { has_error: errorFor('inventory_type_id') },
                ]"
              >
                <label class="required">Inventory type</label>
                <div class="form_input">
                  <select
                    class="form_global"
                    v-model="inventory.inventory_type_id"
                  >
                    <option value="">Select type</option>
                    <option
                      v-for="type in types"
                      :key="type.id"
                      :value="type.id"
                    >
                      {{ type.name }}
                    </option>
                  </select>
                  <v-errors :errors="errorFor('inventory_type_id')"></v-errors>
                </div>
              </div>
              <div
                :class="[
                  'form_row',
                  { has_error: errorFor('inventory_brand_id') },
                ]"
              >
                <label class="required">Inventory brand</label>
                <div class="form_input">
                  <select
                    class="form_global"
                    v-model="inventory.inventory_brand_id"
                  >
                    <option value="">Select brand</option>
                    <option
                      v-for="brand in brands"
                      :key="brand.id"
                      :value="brand.id"
                    >
                      {{ brand.name }}
                    </option>
                  </select>
                  <v-errors :errors="errorFor('inventory_brand_id')"></v-errors>
                </div>
              </div>
              <div
                :class="[
                  'form_row',
                  { has_error: errorFor('inventory_name_id') },
                ]"
              >
                <label class="required">Inventory name</label>
                <div class="form_input">
                  <select
                    class="form_global"
                    v-model="inventory.inventory_name_id"
                  >
                    <option value="">Select name</option>
                    <option
                      v-for="name in names"
                      :key="name.id"
                      :value="name.id"
                    >
                      {{ name.name }}
                    </option>
                  </select>
                  <v-errors :errors="errorFor('inventory_name_id')"></v-errors>
                </div>
              </div>
              <div
                :class="[
                  'form_row',
                  { has_error: errorFor('inventory_location_id') },
                ]"
              >
                <label class="required">Inventory location</label>
                <div class="form_input">
                  <select
                    class="form_global"
                    v-model="inventory.inventory_location_id"
                  >
                    <option value="">Select location</option>
                    <option
                      v-for="location in locations"
                      :key="location.id"
                      :value="location.id"
                    >
                      {{ location.name }}
                    </option>
                  </select>
                  <v-errors
                    :errors="errorFor('inventory_location_id')"
                  ></v-errors>
                </div>
              </div>
              <div :class="['form_row', { has_error: errorFor('notes') }]">
                <label>Notes</label>
                <div class="form_inline">
                  <text-editor
                    v-model:text="inventory['notes']"
                    :id="'notes'"
                  ></text-editor>
                  <v-errors :errors="errorFor('notes')"></v-errors>
                </div>
              </div>
            </div>
            <div class="col_6 pl_20">
              <div :class="['form_row', { has_error: errorFor('serial') }]">
                <label class="required">Serial</label>
                <div class="form_inline">
                  <input
                    type="text"
                    class="form_global"
                    v-model="inventory.serial"
                  />
                  <v-errors :errors="errorFor('serial')"></v-errors>
                </div>
              </div>
              <div :class="['form_row', { has_error: errorFor('status') }]">
                <label class="required">Status</label>
                <div class="form_input">
                  <select class="form_global" v-model="inventory.status">
                    <option value="">Select status</option>
                    <option value="in-use">In use</option>
                    <option value="fault">Fault</option>
                    <option value="stock">Stock</option>
                  </select>
                  <v-errors :errors="errorFor('status')"></v-errors>
                </div>
              </div>
              <div
                :class="['form_row', { has_error: errorFor('inventory_date') }]"
              >
                <label class="required">Inventory date</label>
                <div class="form_input">
                  <date-picker
                    v-model:input="inventory.inventory_date"
                  ></date-picker>
                  <v-errors :errors="errorFor('inventory_date')"></v-errors>
                </div>
              </div>

              <div class="form_row">
                <label></label>
                <div class="form_inline">
                  <button
                    class="btn btn_primary"
                    :disabled="lyLoading"
                    @click.prevent="update"
                    v-if="$route.params.id"
                  >
                    Update
                  </button>
                  <button
                    class="btn btn_primary"
                    :disabled="lyLoading"
                    @click.prevent="submit"
                    v-else
                  >
                    Save
                  </button>
                  <router-link
                    v-if="$route.params.id"
                    :to="{ name: 'inventories' }"
                    class="btn btn_transparent has_border_radius ml_10"
                    >Cancel</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoaderMaskComponent from '@/components/LoaderMaskComponent.vue';
import TextEditor from '@/components/shared/TextEditor';
import DatePicker from '@/components/shared/DatePicker';
export default {
  name: 'inventorie-form',
  components: { LoaderMaskComponent, TextEditor, DatePicker },
  data() {
    return {
      lyLoading: false,
      inventory: {
        inventory_type_id: '',
        inventory_brand_id: '',
        inventory_name_id: '',
        inventory_location_id: '',
        status: '',
        serial: '',
        inventory_date: '',
        notes: '',
      },
      types: [],
      brands: [],
      names: [],
      locations: [],
    };
  },
  created() {
    if (this.$route.params.id) {
      this.loadData(this.$route.params.id);
    }
    this.getInventoryTypes();
    this.getInventoryBrands();
    this.getInventoryNames();
    this.getInventoryLocations();
  },
  methods: {
    getInventoryTypes() {
      this.axios.get('/active-inventory-types').then(({ data }) => {
        this.types = data.data;
      });
    },
    getInventoryBrands() {
      this.axios.get('/active-inventory-brands').then(({ data }) => {
        this.brands = data.data;
      });
    },
    getInventoryNames() {
      this.axios.get('/active-inventory-names').then(({ data }) => {
        this.names = data.data;
      });
    },
    getInventoryLocations() {
      this.axios.get('/active-inventory-locations').then(({ data }) => {
        this.locations = data.data;
      });
    },
    loadData(inventoryId) {
      this.lyLoading = true;
      this.axios
        .get('/inventories/' + inventoryId)
        .then((response) => {
          this.inventory = response.data.data;
        })
        .catch(() => {
          this.showFailMsg('No inventory exists!');
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    submit() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();

      Object.keys(this.inventory).forEach((key) => {
        formData.append(key, this.inventory[key] ? this.inventory[key] : '');
      });

      this.axios
        .post('/inventories', formData)
        .then(() => {
          this.resetForm();
          this.showSuccessMsg('Inventory Created Successfully!');
          this.$router.push({ name: 'inventories' });
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
          this.showFailMsg(err.response.data.message);
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },

    update() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();

      formData.append('_method', 'PATCH');

      Object.keys(this.inventory).forEach((key) => {
        formData.append(key, this.inventory[key] ? this.inventory[key] : '');
      });

      this.axios
        .post('/inventories/' + this.$route.params.id, formData)
        .then(() => {
          this.showSuccessMsg('Inventory Update Successfully!');
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    resetForm() {
      this.inventories = {
        inventory_type_id: '',
        inventory_brand_id: '',
        inventory_name_id: '',
        inventory_location_id: '',
        status: '',
        serial: '',
        inventory_date: '',
        notes: '',
      };
    },
  },
};
</script>
<style scoped>
.create_item_tab button {
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.btn_back {
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.font_italic {
  position: relative;
  display: block;
  left: 120px;
  padding-top: 5px;
}
</style>
